import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=030bc4ca&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=030bc4ca&lang=scss&scoped=true&"
import style1 from "./ClientList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bc4ca",
  null
  
)

export default component.exports